import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var StudyGuide = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m18.914 31.672 11.155-14.701v.025a.926.926 0 0 0-.868-1.472l-18.257 2.473a.918.918 0 0 0-.768.68.925.925 0 0 0 .334.977l5.838 4.414.905 7.159a.939.939 0 0 0 1.223.763.918.918 0 0 0 .438-.318Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10.195c4.958-3.932 12.283-5.675 21.07-5.082a.943.943 0 0 1 .93.928v29.068a.89.89 0 0 1-.347.718.956.956 0 0 1-.769.197c-1.276-.26-12.753-2.374-20.364 2.82a.943.943 0 0 1-1.04 0c-7.61-5.206-19.125-3.08-20.364-2.82a.993.993 0 0 1-.781-.197.93.93 0 0 1-.335-.718V6.041a.938.938 0 0 1 .868-.928C9.544 4.52 16.88 6.263 22 10.195Zm.868 26.287c6.965-3.907 15.963-2.98 19.21-2.473l.1-27.103c-8.106-.395-14.724 1.298-19.26 4.946a.641.641 0 0 1 0 .26v1.236a.926.926 0 0 1-.93.927.93.93 0 0 1-.93-.927v-1.224a.642.642 0 0 1 0-.26C16.522 8.155 9.866 6.511 1.798 6.92v27.04c3.247-.457 12.245-1.372 19.21 2.473v-3.3a.926.926 0 0 1 .93-.928.93.93 0 0 1 .93.927v3.35Z"
  }));
});
StudyGuide.displayName = 'StudyGuide';
StudyGuide.defaultProps = {
  'aria-label': 'StudyGuide'
};
export default StudyGuide;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/StudyGuide.js
// module id = 3293
// module chunks = 11